import React, { Component } from "react";

import {
  CButton,
  CInput,
  CSpinner,
  CModal,
  CModalFooter,
  CModalBody,
  CModalHeader,
  CLabel
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";

import "react-bootstrap-table/dist//react-bootstrap-table-all.min.css";

class EditFileModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      loading: false
    };
  }

  componentDidMount() {
    this.setState({ name: this.props.selected.name });
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  editFile() {
    if (this.state.name === "") {
      return;
    }

    this.setState({ loading: true });

    axios
      .post(
        `${URL.api}content/doc/update/${this.props.selected.id}`,
        { name: this.state.name },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.props.onClose();
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  render() {
    return (
      <CModal
        size="md"
        centered
        show
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>Editar arquivo</CModalHeader>
        <CModalBody>
          <CLabel className="font-weight-bold">Nome do arquivo</CLabel>
          <CInput
            type="text"
            value={this.state.name}
            onChange={e => this.setState({ name: e.target.value })}
            placeholder="Digite o nome do arquivo"
          />
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            className="d-flex justify-content-center align-items-center"
            onClick={() => this.editFile()}
          >
            <span className={this.state.loading ? "invisible" : ""}>
              Editar
            </span>
            {this.state.loading && (
              <CSpinner
                size="sm"
                color="white"
                style={{ position: "absolute" }}
              />
            )}
          </CButton>{" "}
          <CButton color="secondary" onClick={() => this.props.onClose()}>
            Cancelar
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditFileModal);
